import { render } from "./EmailRulesGrid.vue?vue&type=template&id=6c11596a"
import script from "./EmailRulesGrid.vue?vue&type=script&lang=js"
export * from "./EmailRulesGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__